import React from 'react';

/** Source Spines SP-3a — the intent-chat panel composer.
 *  RF discipline: `nodrag nowheel` so typing/scrolling inside the node never
 *  pans/drags the canvas; every key stopPropagation so RF's keyboard shortcuts
 *  (delete, etc.) don't fire while composing. Enter (not during IME
 *  composition, not Shift) sends the trimmed value + clears; Shift+Enter is a
 *  newline. Focus follows an explicit click only (the textarea is not autofocus,
 *  so mounting the panel never steals focus from the canvas). */
const IntentChatComposer: React.FC<{ onSend: (t: string) => void; disabled?: boolean }> = ({
  onSend,
  disabled,
}) => {
  const [text, setText] = React.useState('');

  const onKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    e.stopPropagation();
    if (e.key === 'Enter' && !e.shiftKey && !(e.nativeEvent as any).isComposing) {
      e.preventDefault();
      const v = text.trim();
      if (v) {
        onSend(v);
        setText('');
      }
    }
  };

  return (
    <textarea
      className="nodrag nowheel w-full resize-none rounded-b-md border-t border-amber-500/40 bg-transparent px-2.5 py-1.5 text-[12px] leading-snug outline-none placeholder:text-gray-500 disabled:opacity-50"
      rows={2}
      value={text}
      disabled={disabled}
      placeholder="Reply to the foreman…"
      onChange={(e) => setText(e.target.value)}
      onKeyDown={onKeyDown}
      onKeyUp={(e) => e.stopPropagation()}
    />
  );
};

export default IntentChatComposer;
